export const ENDPOINTS = {
  auth: {
    login: '/auth/login', // POST
    me: '/auth/me', // GET
  },
  geo: {
    searchPosition: '/geocoding/geocode', // POST
  },
  users: {
    list: '/users', // GET
    me: '/auth/me', // GET - 현재 사용자 정보 조회
    create: '/users', // POST
    update: (id: string) => `/users/${id}`, // PUT
    delete: (id: string) => `/users/${id}`, // DELETE
    checkLoginId: (loginId: string) => `/users/check-login-id/${loginId}`, // GET
    changePassword: (id: string) => `/users/${id}/change-password`, // PUT
  },
  sites: {
    nextAvailableId: '/sites/next-available-id', // GET
    checkDuplication: (siteId: string) => `/sites/check-duplicate/${siteId}`, // GET
    list: '/sites', // GET
    detail: (siteId: string) => `/sites/${siteId}`, // GET
    stats: '/sites/stats', // GET
    accessCheck: (siteId: string) => `/sites/${siteId}/access-check`, // GET
    create: '/sites', // POST
    update: (siteId: string) => `/sites/${siteId}`, // PUT
    delete: (siteId: string) => `/sites/${siteId}`, // DELETE

    // 매니저 관리
    managers: (siteId: string) => `/sites/${siteId}/managers`, // GET
    addManager: (siteId: string, managerId: string) =>
      `/sites/${siteId}/managers/${managerId}`, // POST
    removeManager: (siteId: string, managerId: string) =>
      `/sites/${siteId}/managers/${managerId}`, // DELETE

    // 모터 관리
    resetMotor: (siteId: string) => `/sites/${siteId}/motor/reset`, // POST

    // 사진 관리
    photos: (siteId: string) => `/sites/${siteId}/photos`, // GET, POST
    deletePhoto: (siteId: string, photoId: string) =>
      `/sites/${siteId}/photos/${photoId}`, // DELETE

    // 로그 관리
    logs: (siteId: string) => `/sites/${siteId}/logs`, // GET
    adminLogs: '/sites/logs/admin', // GET
  },
  dashboard: {
    // 기존 API
    motorStatus: (siteId: string) => `/sieng-data/sites/${siteId}/motor-status`, // GET
    waterLevelChart: (siteId: string, period: string) =>
      `/sieng-data/sites/${siteId}/water-level-chart/${period}`, // GET
    siteDetails: (siteId: string) => `/sieng-data/sites/${siteId}/details`, // GET
    errorStatus: (siteId: string) => `/sieng-data/sites/${siteId}/error-status`, // GET
    siteDashboard: (siteId: string) => `/sieng-data/sites/${siteId}/dashboard`, // GET

    // 현장 종합 상태 조회 API
    comprehensiveStatus: (siteId: string) =>
      `/sieng-data/sites/${siteId}/comprehensive-status`, // GET

    // 🚀 새로운 세분화된 API v2
    basicInfo: (siteId: string) => `/sieng-data/v2/sites/${siteId}/basic-info`, // GET
    realtimeStatus: (siteId: string) =>
      `/sieng-data/v2/sites/${siteId}/realtime-status`, // GET
    motorStatistics: (siteId: string) =>
      `/sieng-data/v2/sites/${siteId}/motor-statistics`, // GET
    alerts: (siteId: string) => `/sieng-data/v2/sites/${siteId}/alerts`, // GET
    summary: (siteId: string) => `/sieng-data/v2/sites/${siteId}/summary`, // GET
  },
  inspections: {
    list: '/site-inspections', // GET - 모든 점검 기록 조회 (접근 가능한 사이트만)
    create: '/site-inspections', // POST - 점검 기록 생성
    detail: (id: string) => `/site-inspections/${id}`, // GET - 특정 점검 기록 조회
    update: (id: string) => `/site-inspections/${id}`, // PUT - 점검 기록 수정
    delete: (id: string) => `/site-inspections/${id}`, // DELETE - 점검 기록 삭제 (소프트 삭제)
    bySite: (siteId: string) => `/site-inspections/site/${siteId}`, // GET - 특정 사이트의 점검 기록 조회
  },
  sms: {
    send: '/sms/send', // POST - SMS 발송
  },
};
